'use strict';

var cov_wvz8lqkg0 = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\account\\account.js',
      hash = '5657d7f5c004bc4425308f2402681ffe247d0ada',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\account\\account.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 30
        }
      },
      '1': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      '2': {
        start: {
          line: 6,
          column: 22
        },
        end: {
          line: 11,
          column: 25
        }
      },
      '3': {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 17,
          column: 9
        }
      },
      '4': {
        start: {
          line: 13,
          column: 8
        },
        end: {
          line: 13,
          column: 21
        }
      },
      '5': {
        start: {
          line: 16,
          column: 8
        },
        end: {
          line: 16,
          column: 45
        }
      },
      '6': {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 33,
          column: 6
        }
      },
      '7': {
        start: {
          line: 21,
          column: 22
        },
        end: {
          line: 26,
          column: 24
        }
      },
      '8': {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 32,
          column: 9
        }
      },
      '9': {
        start: {
          line: 28,
          column: 21
        },
        end: {
          line: 28,
          column: 25
        }
      },
      '10': {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 59
        }
      },
      '11': {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 45
        }
      },
      '12': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 39,
          column: 6
        }
      },
      '13': {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 38,
          column: 9
        }
      },
      '14': {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 48
        }
      },
      '15': {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 45,
          column: 6
        }
      },
      '16': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 44,
          column: 9
        }
      },
      '17': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 48
        }
      },
      '18': {
        start: {
          line: 49,
          column: 0
        },
        end: {
          line: 54,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 87
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 30
          },
          end: {
            line: 5,
            column: 31
          }
        },
        loc: {
          start: {
            line: 5,
            column: 44
          },
          end: {
            line: 18,
            column: 5
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 12,
            column: 35
          },
          end: {
            line: 12,
            column: 36
          }
        },
        loc: {
          start: {
            line: 12,
            column: 41
          },
          end: {
            line: 15,
            column: 7
          }
        },
        line: 12
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 10
          }
        },
        loc: {
          start: {
            line: 15,
            column: 15
          },
          end: {
            line: 17,
            column: 7
          }
        },
        line: 15
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 20,
            column: 26
          },
          end: {
            line: 20,
            column: 27
          }
        },
        loc: {
          start: {
            line: 20,
            column: 40
          },
          end: {
            line: 33,
            column: 5
          }
        },
        line: 20
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 27,
            column: 35
          },
          end: {
            line: 27,
            column: 36
          }
        },
        loc: {
          start: {
            line: 27,
            column: 41
          },
          end: {
            line: 30,
            column: 7
          }
        },
        line: 27
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 30,
            column: 9
          },
          end: {
            line: 30,
            column: 10
          }
        },
        loc: {
          start: {
            line: 30,
            column: 15
          },
          end: {
            line: 32,
            column: 7
          }
        },
        line: 30
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 35,
            column: 20
          },
          end: {
            line: 35,
            column: 21
          }
        },
        loc: {
          start: {
            line: 35,
            column: 32
          },
          end: {
            line: 39,
            column: 5
          }
        },
        line: 35
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 36,
            column: 53
          },
          end: {
            line: 36,
            column: 54
          }
        },
        loc: {
          start: {
            line: 36,
            column: 64
          },
          end: {
            line: 38,
            column: 7
          }
        },
        line: 36
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 41,
            column: 17
          },
          end: {
            line: 41,
            column: 18
          }
        },
        loc: {
          start: {
            line: 41,
            column: 29
          },
          end: {
            line: 45,
            column: 5
          }
        },
        line: 41
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 42,
            column: 55
          },
          end: {
            line: 42,
            column: 56
          }
        },
        loc: {
          start: {
            line: 42,
            column: 66
          },
          end: {
            line: 44,
            column: 7
          }
        },
        line: 42
      }
    },
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0
    },
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountController = function AccountController($scope, $http, $rootScope, $mdDialog, $state, myVars, $window, ngNotify) {
  _classCallCheck(this, AccountController);

  ++cov_wvz8lqkg0.f[0];
  ++cov_wvz8lqkg0.s[0];

  $scope.checkinfo = myVars;

  ++cov_wvz8lqkg0.s[1];
  $scope.showCancelDialog = function (ev) {
    ++cov_wvz8lqkg0.f[1];

    var confirm = (++cov_wvz8lqkg0.s[2], $mdDialog.confirm().title('Bạn có chắc chắn muốn hủy dịch vụ phong thủy tài lộc tại  http://phongthuy.vtlucky.vn ').textContent('').targetEvent(ev).ok('Đồng ý').cancel('Hủy bỏ'));
    ++cov_wvz8lqkg0.s[3];
    $mdDialog.show(confirm).then(function () {
      ++cov_wvz8lqkg0.f[2];
      ++cov_wvz8lqkg0.s[4];

      $scope.huy();
    }, function () {
      ++cov_wvz8lqkg0.f[3];
      ++cov_wvz8lqkg0.s[5];

      $state.go('app', {}, { reload: true });
    });
  };

  ++cov_wvz8lqkg0.s[6];
  $scope.showDkDialog = function (ev) {
    ++cov_wvz8lqkg0.f[4];

    var confirm = (++cov_wvz8lqkg0.s[7], $mdDialog.confirm().title('Bạn có chắc chắn muốn đăng ký dịch vụ ').textContent('').targetEvent(ev).ok('Có').cancel('Không'));
    ++cov_wvz8lqkg0.s[8];
    $mdDialog.show(confirm).then(function () {
      ++cov_wvz8lqkg0.f[5];

      var data = (++cov_wvz8lqkg0.s[9], true);
      ++cov_wvz8lqkg0.s[10];
      $rootScope.$emit('CallMethodRegister', { ev: ev, data: data });
    }, function () {
      ++cov_wvz8lqkg0.f[6];
      ++cov_wvz8lqkg0.s[11];

      $state.go('app', {}, { reload: true });
    });
  };

  ++cov_wvz8lqkg0.s[12];
  $scope.dangky = function () {
    ++cov_wvz8lqkg0.f[7];
    ++cov_wvz8lqkg0.s[13];

    $http.post($rootScope.apiOpen + 'dangky').then(function (results) {
      ++cov_wvz8lqkg0.f[8];
      ++cov_wvz8lqkg0.s[14];

      $window.location = results.data.message;
    });
  };

  ++cov_wvz8lqkg0.s[15];
  $scope.huy = function () {
    ++cov_wvz8lqkg0.f[9];
    ++cov_wvz8lqkg0.s[16];

    $http.post($rootScope.apiOpen + 'huy/' + 1).then(function (results) {
      ++cov_wvz8lqkg0.f[10];
      ++cov_wvz8lqkg0.s[17];

      $window.location = results.data.message;
    });
  };
};

++cov_wvz8lqkg0.s[18];


angular.module('app').component('account', {
  templateUrl: 'app/account/account.html',
  controller: AccountController
});